import { MemberIntro } from './MemberIntro';

export default MemberIntro;